import React from "react";
import styled from "styled-components";
// Components
import PricingTable from "../Elements/PricingTable";

export default function Pricing() {
  return (
    <Wrapper id="pricing">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">Transparent Pricing for Every Budget</h1>
            <p className="font13">
              We believe in fair and flexible pricing tailored to your needs. Whether you're a startup or an established business, our plans are designed               
              to deliver exceptional value without hidden costs. <br /> Explore our options and find the perfect fit for your goals.
            </p>
          </HeaderInfo>
          <TablesWrapper className="flexSpaceNull">
            <TableBox>
              <PricingTable
                icon="roller"
                price="$19.99/mo"
                title="Starter"
                text="Ideal for individuals and small projects, our Starter plan gives you the essentials to begin with confidence. 
                Enjoy core features, reliable support, and room to grow—all at an affordable price." 
                offers={[
                  { name: "Basic custom software development", cheked: true },
                  { name: "Up to 5 features/modules", cheked: true },
                  { name: "1-month post-launch support", cheked: true },
                  { name: "API integrations", cheked: false },
                  { name: "Bug fixes & minor updates", cheked: false },
                  { name: "Priority support & SLAs", cheked: false },
                  { name: "End-to-end solution", cheked: false },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox>
            <TableBox>
              <PricingTable
                icon="monitor"
                price="$49.99/mo"
                title="Basic"
                text="Our Basic plan covers everything you need to get up and running smoothly. Perfect for growing businesses, 
                it balances affordability with powerful tools."
                offers={[
                  { name: "Full-stack development", cheked: true },
                  { name: "UI/UX design included", cheked: true },
                  { name: "3-month support & Maintenance", cheked: true },
                  { name: "API integrations", cheked: true },
                  { name: "Bug fixes & minor updates", cheked: false },
                  { name: "Priority support & SLAs", cheked: false },
                  { name: "End-to-end custom solution ", cheked: false },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox>
            <TableBox>
              <PricingTable
                icon="browser"
                price="$59.99/mo"
                title="Golden"
                text="Our Golden plan delivers top-tier features, priority support, and exclusive perks—perfect for businesses ready to scale with confidence. 
                Get the ultimate advantage without compromise."
                offers={[
                  { name: "End-to-end custom solution", cheked: true },
                  { name: "Dedicated team & 24/7 support", cheked: true },
                  { name: "DevOps & cloud deployment", cheked: true },
                  { name: "API integrations", cheked: true },
                  { name: "Bug fixes & minor updates", cheked: true },
                  { name: "Priority support & SLAs", cheked: true },
                ]}
                action={() => alert("clicked")}
              />
            </TableBox>
          </TablesWrapper>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding: 50px 0;
`;
const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;
const TablesWrapper = styled.div`
  @media (max-width: 860px) {
    flex-direction: column;
  }
`;
const TableBox = styled.div`
  width: 31%;
  @media (max-width: 860px) {
    width: 100%;
    max-width: 370px;
    margin: 0 auto
  }
`;




